var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3883 10.4129C26.7884 10.9677 26.7831 11.8722 27.3764 12.4331L33.869 18.5714H3.19461C2.35085 18.5714 1.66683 19.211 1.66683 20C1.66683 20.789 2.35085 21.4286 3.19461 21.4286H33.6592L27.3589 27.5836C26.7755 28.1536 26.7967 29.0579 27.4063 29.6035C28.0158 30.149 28.9829 30.1292 29.5663 29.5592L37.4988 21.8095L37.0375 21.3967L37.4988 21.8095C38.6257 20.7087 38.6091 18.9898 37.464 17.9071L29.5489 10.424C28.9555 9.86304 27.9882 9.85806 27.3883 10.4129Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoIcon);
export default __webpack_public_path__ + "static/media/GoIcon.ba65e3bcc1eb963b237add85dd457497.svg";
export { ForwardRef as ReactComponent };